import Cookies from 'js-cookie'

const local = window.localStorage
const TokenKey = 'User-Authorization'

export function getToken() {
  return local.getItem(TokenKey)
  // return Cookies.get(TokenKey)
}

export function setToken(token) {
  return local.setItem(TokenKey, token)
  // return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return local.removeItem(TokenKey)
  // return Cookies.remove(TokenKey)
}

/**
 * 自定义Key
 */
export function getCookies(key) {
  return Cookies.get(key)
}

export function setCookies(key, val) {
  return Cookies.set(key, val)
}

export function removeCookies(key) {
  return Cookies.remove(key)
}
